import { render, staticRenderFns } from "./MaterialSlideShow.vue.js?vue&type=template&id=5a4ae434!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialSlideShow.vue?vue&type=template&id=5a4ae434"
import script from "./MaterialSlideShow.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialSlideShow.vue?vue&type=script&lang=js"
export * from "./MaterialSlideShow.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialSlideShow.vue?vue&type=script&lang=js"
import style0 from "./MaterialSlideShow.vue.scss?vue&type=style&index=0&id=5a4ae434&prod&lang=scss!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialSlideShow.vue?vue&type=style&index=0&id=5a4ae434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports